import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LOGO_BLACK, LOGO_WHITE } from "@/lib/assets";

const NAV = [
  { label: "Studio", target: "#manifesto" },
  { label: "Approach", target: "#fusion" },
  { label: "Expertise", target: "#expertise" },
  { label: "Contact", target: "#contact" },
];

export default function Header({ onNav }) {
  const [open, setOpen] = useState(false);

  const go = (target) => {
    setOpen(false);
    onNav(target);
  };

  return (
    <>
      <motion.header
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, delay: 2.2, ease: [0.22, 1, 0.36, 1] }}
        className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-6 py-4 lg:px-14 backdrop-blur-xl bg-[#FBF9F5]/80 border-b border-[#121110]/10"
      >
        <button data-testid="nav-brand-logo" onClick={() => go("#top")} className="flex items-center">
          <img src={LOGO_BLACK} alt="Akkas Music" className="h-16 lg:h-20 w-auto object-contain" />
        </button>

        <nav className="hidden md:flex items-center gap-9 lg:gap-11">
          {NAV.map((item) => (
            <button
              key={item.label}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              onClick={() => go(item.target)}
              className="link-underline font-mono-accent text-[11px] uppercase tracking-[0.25em] text-[#5C5650] hover:text-[#121110] pb-1"
              style={{ backgroundImage: "linear-gradient(#121110,#121110)" }}
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <button
            data-testid="nav-contact-button"
            onClick={() => go("#contact")}
            className="hidden sm:block hairline-btn border border-[#121110]/25 px-5 py-2.5 font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#121110] hover:bg-[#121110] hover:text-[#FBF9F5]"
          >
            Enquire
          </button>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(true)}
            className="md:hidden text-[#121110] p-1"
            aria-label="Open menu"
          >
            <Menu className="h-6 w-6" strokeWidth={1.25} />
          </button>
        </div>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className="fixed inset-0 z-[90] bg-[#121110] text-[#FBF9F5] flex flex-col px-6 py-6"
          >
            <div className="flex items-center justify-between">
              <img src={LOGO_WHITE} alt="Akkas Music" className="h-16 w-auto object-contain" />
              <button
                data-testid="mobile-menu-close"
                onClick={() => setOpen(false)}
                className="text-[#FBF9F5] p-1"
                aria-label="Close menu"
              >
                <X className="h-7 w-7" strokeWidth={1.25} />
              </button>
            </div>

            <nav className="flex flex-1 flex-col justify-center gap-2">
              {NAV.map((item, i) => (
                <motion.button
                  key={item.label}
                  data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
                  initial={{ opacity: 0, y: 24 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.1 + i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                  onClick={() => go(item.target)}
                  className="text-left font-serif-display font-light text-5xl sm:text-6xl leading-tight text-[#FBF9F5] hover:text-[#C5A880] transition-colors duration-300"
                >
                  {item.label}
                </motion.button>
              ))}
            </nav>

            <span className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/40">
              Akkas Music — Sonic Branding
            </span>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
